















































































































































































































































































































































































































































































































import {
	BillingApi,
	EventTypesApi,
	FeedTankSensorTypeEnum,
	FeedTypeLevelMetricEnum,
	ProductsApi,
	UpdateBilling,
} from '@/api';
import { Component, Prop } from 'vue-property-decorator';
import {
	createEventSubscription,
	createEventSubscriptionGroups,
	deleteEventSubscription,
	EventSubscription,
	EventSubscriptionGroup,
	EventType,
	filterEntityEventSubscriptions,
	filterEntityEventTypes,
	findSubscribableEventTypes,
	getEventParameters,
	patchEventSubscription,
	SubscribableUser,
} from '@/models/event-subscription.ts';
import { Validations } from 'vuelidate-property-decorators';
import { mixins } from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { minValue, required } from 'vuelidate/lib/validators';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import { Constants } from '@/common/Constants';
import { getProductAllowedUserIds } from '@/services/user-service';
import moment from 'moment';

@Component({
	components: { ConfirmModal },
})
export default class EventSubscriptions extends mixins(validationMixin) {
	@Prop(Number)
	private readonly productId?: number;
	@Prop(Object)
	private readonly entity?: any;
	@Prop(String)
	private readonly productType: 'milk' | 'fuel' | 'water' | 'all' | undefined;
	@Prop(String)
	private readonly entityType?: string;

	private productBilling?: UpdateBilling;

	private api: ProductsApi = new ProductsApi();

	private product?: any | null = null;
	private allowedUserIds: number[] = [];

	private eventTypes: EventType[] = [];
	private subscribableEventTypes: EventType[] = [];
	private eventSubscriptions: EventSubscription[] = [];
	private eventSubscriptionGroups: EventSubscriptionGroup[] = [];
	private loading = false;
	private tempSubscriberUpdateArray = [];
	private tempParameterUpdateArray = [];
	private users: SubscribableUser[] = [];
	private fields = [
		{ key: 'title', label: 'Event Type', sortable: true },
		{ key: 'description', label: 'Description' },
		{ key: 'parameters', label: 'Parameters', sortable: true },
		{ key: 'subscriptions', label: 'Subscriptions', sortable: true },
	];
	public blueTopNameArray = [
		'milkPickup',
		'milkingStart',
		'vatOverfilled',
		'milkStartWithoutWash',
		'powerRestored',
	];
	private editParameters = false;
	private editUsers = false;

	private selectedEventType = null;
	private updateEventSubscriptionGroup: EventSubscriptionGroup = {
		name: undefined,
		productId: this.productId!,
		eventTypeId: undefined,
		eventType: undefined,
		parameterContext: null,
		parameters: [],
		subscriptions: [],
	};

	public get shouldShowSMS(): boolean {
		return this.productType != 'water' || this.entity?.billingTier != 'lite';
	}

	public getAllowedAlertMethods() {
		if(this.shouldShowSMS) {
			return ['mail', 'sms', 'push'];
		}
		return ['mail', 'push'];
	}

	//Note: spread operator (...) to remove references to original object
	private createUpdateEventSubscriptionGroup(
		eventType: EventType,
		eventSubscriptionGroup?: EventSubscriptionGroup,
	) {
		this.updateEventSubscriptionGroup.eventTypeId = eventType.id;
		this.updateEventSubscriptionGroup.eventType = {
			...this.eventTypes.find(et => et.id === eventType.id)!,
		};
		if (eventSubscriptionGroup) {
			this.updateEventSubscriptionGroup.key = eventSubscriptionGroup.key!;
			this.updateEventSubscriptionGroup.parameterContext = eventSubscriptionGroup.parameterContext!;
			this.updateEventSubscriptionGroup.parameters = JSON.parse(
				JSON.stringify(eventSubscriptionGroup.parameters),
			);
			//  this.updateEventSubscriptionGroup.parameters =  [
			// ...getEventParameters(eventType.name, eventSubscriptionGroup.parameters),
			// ];
			this.updateEventSubscriptionGroup.subscriptions = [...eventSubscriptionGroup.subscriptions];
		} else {
			this.updateEventSubscriptionGroup.key = undefined;
			this.updateEventSubscriptionGroup.parameterContext = null;
			this.updateEventSubscriptionGroup.parameters = getEventParameters(
				eventType,
				undefined,
				'feedtype' in this.entity ? this.entity.feedtype.levelMetric : undefined,
				'sensorType' in this.entity ? this.entity.sensorType : undefined,
			);
			this.updateEventSubscriptionGroup.subscriptions = [];
		}
	}

	private addRemoveSubscriber(channel: string, user: SubscribableUser, subscribers: any[]) {
		let sub = this.findSubscriber(channel, user.id, subscribers);
		if (sub === undefined) {
			this.addSubscriber(channel, user, subscribers);
		} else {
			this.removeSubscriber(sub, subscribers);
		}
	}

	private removeSubscriber(sub: any, subscribers: any[]) {
		let index = subscribers.findIndex(s => s.userId == sub!.userId && s.channel == sub!.channel);
		if (index >= 0) {
			subscribers.splice(index, 1);
		}
	}
	private addSubscriber(channel: string, user: SubscribableUser, subscribers: any[]) {
		subscribers.push({
			channel: channel,
			userId: user.id,
			user: user,
		});
	}

	private findSubscriber(channel: string, userId: number, subscribers: any[]) {
		return subscribers.find(sub => sub.channel === channel && sub.userId === userId);
	}

	private dayMaxValue(month) {
		if (month == 2) {
			return 28;
		} else if ([4, 6, 9, 11].includes(month)) {
			return 30;
		} else {
			return 31;
		}
		// return new Date(2022, month, 0).getDate();
	}

	private async createUpdateUsers() {
		this.loading = true;

		let EventSubscriptionGroup = this.eventSubscriptionGroups.find(
			esg => esg.key === this.updateEventSubscriptionGroup.key,
		);
		let initialSubscriptionArray = EventSubscriptionGroup
			? EventSubscriptionGroup!.subscriptions
			: [];

		let promiseArray: any[] = [];

		if (this.editUsers) {
			//add subs promise array generated from updated sub array
			let addSubs = this.updateEventSubscriptionGroup.subscriptions.map(sub => {
				return { ...sub };
			});
			//subs to add = updated sub array minus all entrys from the initial sub array
			initialSubscriptionArray.forEach(sub => this.removeSubscriber(sub, addSubs));

			//add to promise array
			addSubs.forEach(sub => {
				promiseArray.push(
					createEventSubscription({
						eventTypeId: this.updateEventSubscriptionGroup.eventTypeId!,
						productId: this.productId!,
						userId: sub.user!.id,
						entityType: this.updateEventSubscriptionGroup.eventType!.entityType
							? this.updateEventSubscriptionGroup.eventType!.entityType
							: this.entityType,
						entityId: this.entity.id,
						channel: sub.channel,
						parameters: this.createParameters(this.updateEventSubscriptionGroup),
					}),
				);
			});

			//remove subs array generated from the initial subs array
			let removeSubs = initialSubscriptionArray.map(sub => {
				return { ...sub };
			});
			//remove subs array = inital sub array - updated sub array
			this.updateEventSubscriptionGroup.subscriptions.forEach(sub => {
				this.removeSubscriber(sub, removeSubs);
			});
			//add to remove subs promise array
			removeSubs.forEach(sub => {
				promiseArray.push(deleteEventSubscription(sub.id!));
			});

			//resolve add/remove promises
			Promise.all(promiseArray).then(
				value => {
					this.load();
				},
				reason => {
					console.log(reason);
					this.loading = false;
				},
			);
			//for each new sub create new subscription with set parameters
			//for each deleted sub delete subscription with set parameters
		} else if (this.editParameters) {
			initialSubscriptionArray.forEach(sub => {
				promiseArray.push(
					patchEventSubscription(sub.id!, {
						id: sub.id!,
						eventTypeId: this.updateEventSubscriptionGroup.eventTypeId!,
						productId: this.productId!,
						userId: sub.user!.id!,
						entityType: this.updateEventSubscriptionGroup.eventType!.entityType
							? this.updateEventSubscriptionGroup.eventType!.entityType
							: this.entityType,
						entityId: this.entity.id,
						channel: sub.channel,
						parameters: this.createParameters(this.updateEventSubscriptionGroup),
					}),
				);
			});
			Promise.all(promiseArray).then(
				value => {
					this.load();
				},
				reason => {
					console.log(reason);
					this.loading = false;
				},
			); //for each sub patch the parameters
		}
	}

	//sanitise and create parameters for submission
	private createParameters(updateEventSubscriptionGroup: EventSubscriptionGroup) {
		let parameters = {};
		if (updateEventSubscriptionGroup.parameters) {
			if (['lowLevel', 'highLevel'].includes(updateEventSubscriptionGroup.eventType!.name)) {
				const levelParams = updateEventSubscriptionGroup.parameters[updateEventSubscriptionGroup.eventType!.name];
				Object.assign(parameters, {
					[levelParams.unit.value]: levelParams.value.value,
				});
				if (levelParams.delayUntil?.type !== 'hidden') {
					Object.assign(parameters, { delayUntil: this.parseDelayUntil(levelParams.delayUntil?.value) });
				}
			} else if (updateEventSubscriptionGroup.eventType!.name === 'daysToEmpty') {
				const daysToEmptyParams =
					updateEventSubscriptionGroup.parameters[updateEventSubscriptionGroup.eventType!.name];
				Object.assign(parameters, {
					days: daysToEmptyParams.days.value,
					delayUntil: this.parseDelayUntil(daysToEmptyParams.delayUntil?.value),
				});
			} else if (
				['withdrawalHours', 'levelChangeHours'].includes(
					updateEventSubscriptionGroup.eventType!.name,
				)
			) {
				let begin = updateEventSubscriptionGroup.parameters[
					updateEventSubscriptionGroup.eventType!.name
				].begin_value.value.split(':');
				let end = updateEventSubscriptionGroup.parameters[
					updateEventSubscriptionGroup.eventType!.name
				].end_value.value.split(':');
				Object.assign(parameters, {
					begin_hours: parseInt(begin[0], 10),
					begin_mins: parseInt(begin[1], 10),
					end_hours: parseInt(end[0], 10),
					end_mins: parseInt(end[1], 10),
				});
			} else {
				Object.keys(
					updateEventSubscriptionGroup.parameters[updateEventSubscriptionGroup.eventType!.name],
				).forEach(key => {
					Object.assign(parameters, {
						[key]:
							updateEventSubscriptionGroup.parameters[updateEventSubscriptionGroup.eventType!.name][
								key
							].value,
					});
				});
			}
		}
		return parameters;
	}

	//converts a "HH:mm:00" time input value to an HHmm integer, or null to clear a previously saved delay
	private parseDelayUntil(value?: string | null): number | null {
		if (!value) return null;
		const [hh, mm] = value.split(':');
		return parseInt(hh, 10) * 100 + parseInt(mm, 10);
	}

	private withdrawalVolumeCheck(value, siblings) {
		let validation =
			this.entity.fluctuation <= value.value && this.entity.nominalVolume >= value.value;
		if (!validation) {
			value.validationFeedback = `Volume must be between ${this.entity.fluctuation} and ${this.entity.nominalVolume}`;
		}
		return validation;
	}

	private lowLevelCheck(value, siblings) {
		const weight =
			'feedtype' in this.entity &&
			this.entity.feedtype?.levelMetric === FeedTypeLevelMetricEnum.Weight;
		let unit = siblings.unit.value;
		let volume =
			this.entityType === 'tanks' || this.entityType === Constants.ENTITY_TYPE_FEED_TANK
				? weight
					? this.entity.nominalWeight
					: this.entity.nominalVolume
				: this.entity.nominal;
		if (unit === 'volume') {
			let validation = volume * 0.05 <= value.value && value.value <= volume * 0.75;
			if (!validation) {
				value.validationFeedback = `Volume must be between ${volume * 0.05} and ${volume * 0.75}`;
			}
			return validation;
		} else if (unit === 'percent') {
			let validation = 5 <= value.value && value.value <= 75;
			if (!validation) {
				value.validationFeedback = `Percentage must be between 5 and 75`;
			}
			return validation;
		} else if (unit === 'weight') {
			const isStrain =
				'sensorType' in this.entity &&
				this.entity.sensorType === FeedTankSensorTypeEnum.Strain;
			if (isStrain) {
				const min = 1000;
				const max = volume * 0.75;
				if (value.value % 500 !== 0 || value.value < min) {
					value.validationFeedback = `Weight must be a multiple of 500 kg with a minimum of ${min} kg`;
					return false;
				}
				if (value.value > max) {
					value.validationFeedback = `Weight must not exceed ${max} kg (75% of nominal weight)`;
					return false;
				}
				return true;
			}
			let validation = volume * 0.05 <= value.value && value.value <= volume * 0.75;
			if (!validation) {
				value.validationFeedback = `Weight must be between ${volume * 0.05} and ${volume * 0.75}`;
			}
			return validation;
		}
		return true;
	}

	private feedDaysToEmptyCheck(value, siblings) {
		if (!Number.isInteger(value.value)) {
			value.validationFeedback = 'Days must be a whole number';
			return false
		}
		const inRange = value.value >= 1 && value.value <= 14;
		if (!inRange) {
			value.validationFeedback = 'Days must be between 1 and 14';
		}
		return inRange;
	}

	private delayUntilCheck(value, siblings) {
		if (!value.value) return true;
		const hour = parseInt(value.value.split(':')[0], 10);
		if (hour === 0 || hour >= 4) return true;
		value.validationFeedback = 'Delay until must be between 4:00 AM and midnight';
		return false;
	}
	
	private highLevelCheck(value, siblings) {
		let unit = siblings.unit.value;
		let volume = this.entityType === 'tanks' ? this.entity.nominalVolume : this.entity.nominal;
		if (unit === 'volume') {
			let validation = volume * 0.25 <= value.value && value.value <= volume * 0.95;
			if (!validation) {
				value.validationFeedback = `volume must be between ${volume * 0.25} and ${volume * 0.95}`;
			}
			return validation;
		} else if (unit === 'percent') {
			let validation = 25 <= value.value && value.value <= 95;
			if (!validation) {
				value.validationFeedback = `percentage must be between 25 and 95`;
			}
			return validation;
		}
		return true;
	}
	private timeCheck(value, siblings) {
		let validation =
			siblings[Object.keys(siblings)[0]].value !== siblings[Object.keys(siblings)[1]].value;
		if (!validation) {
			value.validationFeedback = `${Object.keys(siblings)[0]} cannot be equal to ${
				Object.keys(siblings)[1]
			}`;
		}
		return validation;
	}
	private dayCheck(value, siblings) {
		if (
			!siblings['startDay'] >= 1 &&
			siblings['startDay'].value <= this.dayMaxValue(siblings['startMonth'].value)
		) {
			value.validationFeedback = validation
				? ''
				: `Start Day must be between 1 and ${this.dayMaxValue(siblings['startMonth'].value)}`;
			return false;
		} else if (
			!(
				siblings['endDay'].value >= 1 &&
				siblings['endDay'].value <= this.dayMaxValue(siblings['endMonth'].value)
			)
		) {
			value.validationFeedback = `End Day must be between 1 and ${this.dayMaxValue(
				siblings['endMonth'].value,
			)}  `;
			return false;
		} else if (
			siblings['startDay'].value == siblings['endDay'].value &&
			siblings['startMonth'].value == siblings['endMonth'].value
		) {
			value.validationFeedback = `Start Day & Month cannot be equal to End Day & Month`;
			return false;
		}
		return true;
	}

	@Validations()
	public validations() {
		return {
			updateEventSubscriptionGroup: {
				parameters: {
					lowLevel: {
						unit: { value: { required } },
						value: { levelCheck: this.lowLevelCheck, value: { required } },
						delayUntil: { delayUntilCheck: this.delayUntilCheck, value: {} },
					},
					highLevel: {
						unit: { value: { required } },
						value: { levelCheck: this.highLevelCheck, value: { required } },
					},
					withdrawalHours: {
						begin_value: { timeCheck: this.timeCheck, value: { required } },
						end_value: { timeCheck: this.timeCheck, value: { required } },
					},
					levelChangeHours: {
						begin_value: { timeCheck: this.timeCheck, value: { required } },
						end_value: { timeCheck: this.timeCheck, value: { required } },
					},
					usageSupplyByFixedPeriod: {
						startDay: { dayCheck: this.dayCheck, value: { required } },
						startMonth: { value: { required } },
						endDay: { dayCheck: this.dayCheck, value: { required } },
						endMonth: { value: { required } },
						volume: { value: { required, minValue: minValue(0.0001) } },
					},
					usageUsageByFixedPeriod: {
						startDay: { dayCheck: this.dayCheck, value: { required } },
						startMonth: { value: { required } },
						endDay: { dayCheck: this.dayCheck, value: { required } },
						endMonth: { value: { required } },
						volume: { value: { required, minValue: minValue(0.0001) } },
					},
					usageSupplyByPeriod: {
						aboveBelow: { value: { required } },
						volume: { value: { required, minValue: minValue(0.0001) } },
						periodValue: { value: { required } },
						periodUnits: { value: { required } },
					},
					usageUsageByPeriod: {
						aboveBelow: { value: { required } },
						volume: { value: { required, minValue: minValue(0.0001) } },
						periodValue: { value: { required } },
						periodUnits: { value: { required } },
					},
					withdrawalVolume: {
						condition: { value: { required } },
						absolute: {
							withdrawalVolumeCheck: this.withdrawalVolumeCheck,
							value: { required, minValue: minValue(0.0001) },
						},
					},
					daysToEmpty: {
						days: { feedDaysToEmptyCheck: this.feedDaysToEmptyCheck, value: { required } },
						delayUntil: { delayUntilCheck: this.delayUntilCheck, value: {} },
					},
					lowSupplyFlow: { flow: { value: { required, minValue: minValue(0.0001) } } },
					lowUsageFlow: { flow: { value: { required, minValue: minValue(0.0001) } } },
					highSupplyFlow: { flow: { value: { required, minValue: minValue(0.0001) } } },
					highUsageFlow: { flow: { value: { required, minValue: minValue(0.0001) } } },
					overnightSupplyUse: { volume: { value: { required, minValue: minValue(0.0001) } } },
					overnightUsageUse: { volume: { value: { required, minValue: minValue(0.0001) } } },
					refill: {},
					levelChange: {},
					monthlyReport: {},
					withdrawalWeekend: {},
					tankBalance: { period: {} },
					milkPickup: {},
					milkingStart: {},
					milkingEnd: {},
					milkStartWithoutWash: {},
					vatWashEnd: {},
					powerRestored: {},
					milkScoreChanged: {},
					powerOut: {},
					vatStateChange: {},
					stirrerOffMilkInVat: {},
					vatOverfilled: {},
					milkTooWarm: {},
					milkTooCold: {},
					milkInletTooWarm: {},
					milkingEndTooWarm: {},
				},
			},
		};

		// parameterValueAgainstEntityValue: this.validateAgainstEntityValue,
		// againstSiblingParameter: this.validateAgainstSiblingParameter,
		// nonNegative: this.nonZeroNegativeParam,
		// value: { required },
	}
	private iconChannelDict = {
		sms: { text: 'SMS', icon: 'phone' },
		mail: { text: 'Email', icon: 'envelope' },
		push: { text: 'Push', icon: 'bell' },
	};

	private deleteGroup(e: EventSubscriptionGroup, params: { modalId: string }) {
		this.loading = true;

		let promiseArray: any[] = [];
		e.subscriptions.forEach(sub => promiseArray.push(deleteEventSubscription(sub.id!)));
		Promise.all(promiseArray).then(
			value => {
				this.load();
				this.$bvModal.hide(params.modalId);
			},
			reason => {
				console.log(reason);
				this.loading = false;
			},
		);
	}

	public async load() {
		if (this.productId == null) return;

		this.product = (
			await this.api.getProductById(this.productId, {
				params: {
					include: 'users,eventSubscriptions,org,subscriptionitem',
				},
			})
		)?.data;
		this.users = this.product.users as SubscribableUser[];

		this.allowedUserIds = (await getProductAllowedUserIds(this.productId)) ?? [];

		if (this.productType !== 'water') {
			const data = await new BillingApi().currentBilling(this.productId);
			this.productBilling = data.data.data;
		}

		this.eventSubscriptions = filterEntityEventSubscriptions(
			this.product.eventsubscriptions,
			this.entity.id,
			this.entityType,
		) as EventSubscription[];
		const types: any = await new EventTypesApi().getEventTypesByProductType(this.productType!);
		this.eventTypes = filterEntityEventTypes(types.data.data, this.entityType) as EventType[];
		this.eventSubscriptionGroups = createEventSubscriptionGroups(
			this.eventSubscriptions,
			this.eventTypes,
			this.users,
			'feedtype' in this.entity ? this.entity.feedtype?.levelMetric : undefined,
			'sensorType' in this.entity ? this.entity.sensorType : undefined,
		) as EventSubscriptionGroup[];
		this.eventSubscriptionGroups.sort((a, b) => (a.name > b.name ? 1 : -1));
		this.subscribableEventTypes = findSubscribableEventTypes(
			this.eventTypes,
			this.eventSubscriptions,
			this.productBilling?.directTier,
			this.product.subscriptionitem,
		) as EventType[];
		this.subscribableEventTypes.sort((a, b) => (a.name > b.name ? 1 : -1));
		this.loading = false;
	}

	public smallScreen = window.innerWidth;

	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}
	public created() {
		this.loading = true;

		this.load();
		window.addEventListener('resize', this.myEventHandler);
	}
	private groupBy(items: any[], key: string | number) {
		return items.reduce((rv, x) => {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	public isEventTypeAllowed(eventType: EventType) {
		return (
			!this.productBilling?.directTier ||
			eventType.tierList.includes(this.productBilling?.directTier) ||
			(!!this.product.subscriptionitem.trialPlan &&
				moment(this.product.subscriptionitem.trialEndsAt, 'YYYY-MM-DD hh:mm:ss').isAfter(
					moment().utc(),
				) &&
				eventType.tierList.includes(this.product.subscriptionitem.trialPlan))
		);
	}
}
